import {
  createFranchisesResourceGuard,
  deleteFranchisesGuard,
  franchisesCollectionGuard,
  franchisesResourceGuard,
  updateFranchisesResourceGuard,
} from './_api/franchises';

export const resourceGuard = franchisesResourceGuard;
export const addFranchise = createFranchisesResourceGuard;
export const editFranchise = updateFranchisesResourceGuard;
export const deleteFranchise = deleteFranchisesGuard;

export const routeGuard = franchisesCollectionGuard;
